var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        width: "350",
        trigger: "hover",
        "popper-class": "goods-popover",
        "append-to-body": true,
      },
      on: { show: _vm.getGoods },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "goods-wrap",
          staticStyle: { "min-height": "100px" },
        },
        [
          _vm.waitDeliver.length
            ? _c("div", { staticClass: "goods-wrap-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("stores::order::wait")) + " "),
              ])
            : _vm._e(),
          _vm.waitDeliver.length
            ? _c(
                "div",
                { staticClass: "goods-wrap-list" },
                [
                  _vm._l(_vm.waitDeliver, function (item) {
                    return [
                      _c(
                        "div",
                        { key: item.id, staticClass: "goods-wrap-item" },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c(
                                "el-badge",
                                {
                                  attrs: {
                                    value: Number(item.skuNum) || 0,
                                    type: "info",
                                  },
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                    },
                                    attrs: { src: item.skuIcon },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "goods-item-info" }, [
                            _c("p", { staticClass: "more-line" }, [
                              _vm._v(_vm._s(item.spuName)),
                            ]),
                            _c("p", [_vm._v(_vm._s(item.skuAttr))]),
                            _c("p", [
                              _vm._v(
                                "SKU " + _vm._s(_vm.$dataCheck(item.skuId))
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.finishDeliver.length
            ? _c("div", { staticClass: "goods-wrap-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("stores::order::shipping")) + " "),
              ])
            : _vm._e(),
          _vm.finishDeliver.length
            ? _c(
                "div",
                { staticClass: "goods-wrap-list" },
                [
                  _vm._l(_vm.finishDeliver, function (item) {
                    return [
                      _c(
                        "div",
                        { key: item.id, staticClass: "goods-wrap-item" },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c(
                                "el-badge",
                                {
                                  attrs: {
                                    value: Number(item.skuNum) || 0,
                                    type: "info",
                                  },
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                    },
                                    attrs: { src: item.skuIcon },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "goods-item-info" }, [
                            _c("p", { staticClass: "more-line" }, [
                              _vm._v(_vm._s(_vm.$dataCheck(item.spuName))),
                            ]),
                            _c("p", [_vm._v(_vm._s(item.skuAttr))]),
                            _c("p", [
                              _vm._v(
                                "SKU " + _vm._s(_vm.$dataCheck(item.skuId))
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.row.product,
              expression: "row.product",
            },
          ],
          staticStyle: { padding: "5px" },
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [_vm._v(" ... ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }